'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { fc } from './collection-direction';
import { yc, LinePlanGrid, PriceLadder } from './line-plan-grid';
import { ArtifactStatus, IllustrativeBadge } from './playback-controls';
import { ShowcaseIcon } from './scene-primitives';
import { V } from './collection-artifact-primitives';
export const jc = ['Line plan', 'Price ladder', 'Launch timing'];
export function CollectionLinePlan({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = e >= fc,
    n = yc(e);
  return (
    <div className={'flex h-full flex-col'}>
      <ArtifactStatus
        icon={'sheet'}
        title={translateShowcaseNode(showcaseCopy, 'LISI\xC8RE FW27 line plan')}
        done={t}
        working={'Building sheet'}
        doneLabel={'Sheet saved'}
        action={
          <span aria-hidden={!0} className={'max-sm:hidden'}>
            <span
              className={
                'btn btn-sm btn-ink h-7 px-2.5 text-[12px] transition-[opacity,transform] duration-300 ease-[var(--ease)]'
              }
              style={{
                opacity: +!!t,
                transform: t ? 'none' : 'scale(0.97)',
              }}
            >
              <ShowcaseIcon name={'check'} className={'size-3.5'} />
              {translateShowcaseNode(showcaseCopy, 'Approve sheet')}
            </span>
          </span>
        }
      />
      <div
        className={
          'flex h-9 shrink-0 items-center gap-2 border-b border-[color-mix(in_oklch,var(--border)_45%,transparent)] px-3 sm:px-4'
        }
      >
        <span
          className={
            'num text-ink-2 flex h-6 w-11 shrink-0 items-center justify-center rounded-[6px] text-[11.5px] shadow-[inset_0_0_0_1px_var(--line-strong)]'
          }
        >
          {translateShowcaseNode(showcaseCopy, n.ref)}
        </span>
        <span
          aria-hidden={!0}
          className={'text-ink-4 font-serif text-[13px] italic'}
        >
          {translateShowcaseNode(showcaseCopy, 'fx')}
        </span>
        <span className={'num text-ink-2 min-w-0 truncate text-[12.5px]'}>
          {translateShowcaseNode(showcaseCopy, n.text)}
          {translateShowcaseNode(
            showcaseCopy,
            e >= 500 && !t ? (
              <span className={'caret'} data-blink={'true'} />
            ) : null
          )}
        </span>
        <IllustrativeBadge className={'ml-auto shrink-0'} />
      </div>
      <div
        className={'flex flex-1 flex-col gap-4 px-3 pt-3 pb-3 sm:px-4 md:gap-5'}
      >
        <LinePlanGrid t={e} />
        <PriceLadder t={e} start={300} />
      </div>
      <div
        className={
          'flex h-11 shrink-0 items-center gap-1.5 overflow-hidden border-t border-[color-mix(in_oklch,var(--border)_45%,transparent)] px-3 sm:px-4'
        }
      >
        {translateShowcaseNode(
          showcaseCopy,
          jc.map((e, t) => (
            <span
              key={e}
              className={`inline-flex h-7 shrink-0 items-center rounded-full px-3 text-[12px] ${t === 0 ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'text-ink-3 shadow-[inset_0_0_0_1px_var(--line-strong)]'} ${t === 2 ? 'max-sm:hidden' : ''}`}
            >
              {translateShowcaseNode(showcaseCopy, e)}
            </span>
          ))
        )}
      </div>
    </div>
  );
}
export function useMaterialSelection(e) {
  let t = React.useRef(null),
    [n, r] = React.useState([]);
  return (
    React.useLayoutEffect(() => {
      let n = t.current;
      if (!n) return;
      let i = () => {
        let t = (e) => {
            let t = n.querySelector(`[data-anchor="${e}"]`);
            if (!t) return null;
            let r = 0,
              i = 0,
              a = t;
            for (; a && a !== n; ) {
              ((r += a.offsetLeft), (i += a.offsetTop));
              let e = a.offsetParent;
              a = e instanceof HTMLElement ? e : null;
            }
            return {
              left: r,
              right: r + t.offsetWidth,
              top: i,
              bottom: i + t.offsetHeight,
            };
          },
          i = [];
        for (let n of e) {
          let e = t(n.from),
            r = t(n.to);
          if (e && r) {
            if (r.left >= e.right) {
              let t = e.right + 6,
                a = (e.top + e.bottom) / 2,
                o = r.left - 6,
                s = (r.top + r.bottom) / 2,
                c = (t + o) / 2;
              i.push({
                ...n,
                d: `M${t} ${a} C${c} ${a} ${c} ${s} ${o} ${s}`,
                end: {
                  x: o,
                  y: s,
                },
              });
            } else {
              let t = (e.left + e.right) / 2,
                a = e.bottom + 4,
                o = (r.left + r.right) / 2,
                s = r.top - 4,
                c = (a + s) / 2;
              i.push({
                ...n,
                d: `M${t} ${a} C${t} ${c} ${o} ${c} ${o} ${s}`,
                end: {
                  x: o,
                  y: s,
                },
              });
            }
          }
        }
        r(i);
      };
      i();
      let a = new ResizeObserver(i);
      return (a.observe(n), () => a.disconnect());
    }, [e]),
    [t, n]
  );
}
export const Pc = 200;
export const Fc = 900;
export const Ic = 1700;
export const Lc = 480;
export const Rc = Ic + V.length * Lc + 300;
export const zc = Rc + 700;
export const Bc = V.map((e, t) => ({
  from: `mat-${e.material}`,
  to: `prod-${t}`,
}));
export const Vc = (e) =>
  V.find((t) => t.material === e)?.colour.hex ?? '#8B7E6E';
